(() => {
  const root = document.getElementById('FurMilyMain');
  if (!root) return;

  const offerPrices = [
    { match: '3.2L', base: 'A$379.99', oneTime: 'A$189.99', subscribe: 'A$169.99', saved: 'A$20' },
    { match: '4L', base: 'A$399.99', oneTime: 'A$199.99', subscribe: 'A$179.99', saved: 'A$20' },
    { match: '7L', base: 'A$539.99', oneTime: 'A$269.99', subscribe: 'A$239.99', saved: 'A$30' }
  ];

  const variantButtons = [...root.querySelectorAll('[data-fm-variant]')];
  const purchaseButtons = [...root.querySelectorAll('[data-fm-purchase]')];
  const mainPrice = root.querySelector('[data-fm-price]');
  const comparePrice = root.querySelector('[data-fm-compare]');
  const oneTimeNote = root.querySelector('[data-fm-purchase="one-time"] .fm-purchase-copy small');
  const subscribeNote = root.querySelector('[data-fm-purchase="subscribe"] .fm-purchase-copy small');
  const subscribeTitle = root.querySelector('[data-fm-purchase="subscribe"] .fm-purchase-copy strong');
  const subscribeBadge = root.querySelector('[data-fm-purchase="subscribe"] .fm-purchase-badge');
  let purchaseMode = 'one-time';

  const style = document.createElement('style');
  style.textContent = `
    #FurMilyMain .fm-variant-card > strong[data-fm-card-price]{display:flex!important;flex-direction:column!important;align-items:flex-end!important;gap:3px!important;max-width:145px!important;white-space:normal!important;text-align:right!important}
    #FurMilyMain [data-fm-card-price] s{color:#7b8493;font-size:11.5px;line-height:1.1;font-weight:600}
    #FurMilyMain [data-fm-card-price] .fm-card-current{color:#1d2738;font-size:20.5px;line-height:1;font-weight:800;white-space:nowrap}
    #FurMilyMain [data-fm-card-price] .fm-card-discount{display:inline-flex;padding:4px 7px;border-radius:999px;background:#e8a22d;color:#12372f;font-size:9px;line-height:1;font-style:normal;font-weight:900;white-space:nowrap}
    #FurMilyMain .fm-card-saving{display:block!important;margin-top:4px!important;color:#14733f!important;font-size:9.5px!important;line-height:1.25!important;font-style:normal!important;font-weight:800!important;white-space:normal!important}
    #FurMilyMain .fm-card-saving[hidden]{display:none!important}
    @media(max-width:620px){
      #FurMilyMain .fm-variant-card > strong[data-fm-card-price]{max-width:105px!important;gap:2px!important}
      #FurMilyMain [data-fm-card-price] s{font-size:9.5px}
      #FurMilyMain [data-fm-card-price] .fm-card-current{font-size:16px}
      #FurMilyMain [data-fm-card-price] .fm-card-discount{padding:3px 6px;font-size:8px}
      #FurMilyMain .fm-card-saving{font-size:8px;line-height:1.2}
    }
  `;
  document.head.appendChild(style);

  if (subscribeTitle) subscribeTitle.textContent = 'SAVE MORE — SUBSCRIBE & SAVE';
  if (subscribeBadge) subscribeBadge.textContent = 'SAVE 20%';

  const pricesFor = (button) => {
    const label = button?.querySelector('.fm-variant-title')?.textContent || '';
    return offerPrices.find((entry) => label.includes(entry.match));
  };

  const activeVariant = () => variantButtons.find((button) => button.classList.contains('is-active')) || variantButtons[0];

  const render = () => {
    variantButtons.forEach((button) => {
      const prices = pricesFor(button);
      if (!prices) return;
      const shownPrice = purchaseMode === 'subscribe' ? prices.subscribe : prices.oneTime;
      button.dataset.price = shownPrice;
      button.dataset.basePrice = prices.base;
      button.dataset.oneTimePrice = prices.oneTime;
      button.dataset.subscribePrice = prices.subscribe;
      const cardPrice = button.querySelector('[data-fm-card-price]');
      if (cardPrice) {
        cardPrice.innerHTML = `<s>${prices.base}</s><span class="fm-card-current">${shownPrice}</span>${purchaseMode === 'one-time' ? '<em class="fm-card-discount">-50%</em>' : ''}`;
      }

      const sizeCopy = button.querySelector('.fm-size-copy');
      let saving = button.querySelector('.fm-card-saving');
      if (sizeCopy && !saving) {
        saving = document.createElement('em');
        saving.className = 'fm-card-saving';
        sizeCopy.appendChild(saving);
      }
      if (saving) {
        saving.textContent = `${prices.saved} saved compared to one-time purchase`;
        saving.hidden = purchaseMode !== 'subscribe';
      }
    });

    const selectedPrices = pricesFor(activeVariant());
    if (!selectedPrices) return;

    const selectedPrice = purchaseMode === 'subscribe' ? selectedPrices.subscribe : selectedPrices.oneTime;
    if (mainPrice) mainPrice.textContent = selectedPrice;
    if (comparePrice) comparePrice.textContent = selectedPrices.base;

    if (oneTimeNote) oneTimeNote.textContent = 'FurMily™ fountain only';
    if (subscribeNote) {
      subscribeNote.dataset.fmOfferPriceManaged = 'true';
      subscribeNote.textContent = 'Lower price on every fountain size';
    }
  };

  variantButtons.forEach((button) => button.addEventListener('click', () => requestAnimationFrame(render)));
  purchaseButtons.forEach((button) => button.addEventListener('click', () => {
    purchaseMode = button.dataset.fmPurchase === 'subscribe' ? 'subscribe' : 'one-time';
    requestAnimationFrame(render);
  }));

  render();
  setTimeout(render, 1000);
})();
